<template>
  <ul class="nav nav-tabs" id="myTab" role="tablist">
    <li class="nav-item">
      <a class="nav-link active" data-toggle="tab" href="#photos-tab" role="tab" aria-controls="photos-tab">
        <img src="@/assets/images/tab-icon-5.png" alt="icon"></a>
    </li>

    <li class="nav-item">
      <a class="nav-link" data-toggle="tab" href="#dtab6" role="tab" aria-controls="dtab6">
        <img src="@/assets/images/tab-icon-11.png" alt="icon"></a>
    </li>
    <li class="nav-item">
      <a class="nav-link" data-toggle="tab" href="#dtab5" role="tab" aria-controls="dtab5">
        <img src="@/assets/images/tab-icon-1.png" alt="icon">
      </a>
    </li>
  </ul>
</template>
<script>
export default {
  data () {
    return {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/constructionDiary/components/SideBar/ConstructionDiarySideTabsLinks.vue